import { jsx as _jsx } from "react/jsx-runtime";
import { EmployeeTree } from '@core/rc-components';
const getUserInfo = () => {
    return JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
};
const userInfo = getUserInfo();
const getOrgColumns = () => {
    return [
        {
            title: '创建人',
            dataIndex: 'createdEmplName',
            fieldProps: {
                disabled: true,
            },
            initialValue: userInfo.employeeName,
            key: 'createdEmplName',
        },
        {
            title: '所属单位',
            dataIndex: 'createdUnitName',
            fieldProps: {
                disabled: true,
            },
            initialValue: userInfo.companyName,
            key: 'createdUnitName',
        },
        {
            title: '部门',
            dataIndex: 'orgId',
            key: 'orgName',
            fieldProps(form) {
                return {
                    onChange: (value, option) => {
                        form.setFieldsValue({
                            orgName: option.name,
                            orgId: option.id,
                        });
                    },
                    style: {
                        width: '100%',
                    }
                };
            },
            renderFormItem(schema, config, form, action) {
                return _jsx(EmployeeTree, { placeholder: "\u8BF7\u9009\u62E9" });
            },
        },
    ];
};
const getOrgDetailColumns = () => {
    return [
        {
            title: '创建人',
            dataIndex: 'createdEmplName',
            label: '创建人',
            key: 'createdEmplName',
        },
        {
            title: '所属单位',
            dataIndex: 'createdUnitName',
            key: 'createdUnitName',
            label: '所属单位',
        },
        {
            title: '部门',
            dataIndex: 'orgName',
            key: 'orgName',
            label: '部门',
        },
    ];
};
export const ORG_COLUMNS = getOrgColumns();
export const ORG_DETAIL_COLUMNS = getOrgDetailColumns();
